import Form from 'react-bootstrap/Form';




const NewsLetterCheckbox =(props) =>{
  

  const ChildCheckboxClicked=(e)=>{
      props.CheckboxClicked(e);
  };
  
  return ( <div key={props.keyCounter+"-"+props.label} className="newsletter-form-check newsletter-checkbox-text col-12 col-md-12">
    {/* <input  */}
    <Form.Check
    //className="form-check-input" 
        className="d-flex" 
        type="checkbox" 
        id={props.checkboxItem.id}
        data-choice={props.label}
        data-category={props.checkboxItem.category}
        checked={props.checkboxItem.checked }
        onChange={(e)=>ChildCheckboxClicked(e)}
        aria-required={false}
      />
    <label className="form-check-label"
           //htmlFor={props.label+"-news-letter"}
           htmlFor={props.checkboxItem.id}
           >
        {props.checkboxItem.label}
    </label>
</div>)

};

export default NewsLetterCheckbox;